module.exports = __webpack_public_path__ + "img/fd8904ba156126a9e3b2ae40278b2fd8.svg";